export const MemberRoleEnum = {
  owner: 'owner', // user who has created the workspace (can't be removed but can transfer the ownership)
  admin: 'admin', // can change workspace settings & Billing, can invite another members
  member: 'member', // cannot change workspace settings nor invite another members
} as const;
export type MemberRoleEnum =
  (typeof MemberRoleEnum)[keyof typeof MemberRoleEnum];
